















import { defineComponent } from '@vue/composition-api';

const name = 'ttam-ad-name-add-button';
export default defineComponent({
  name,
  setup(props, { emit }) {
    const onClick = () => {
      emit('click');
    };
    return {
      name,
      onClick,
    };
  },
});
